import { TBoardId, TCardId } from '../../../../../../../types/types';
import { TCommentId } from '../../../../../../../store/model/card/types/IComment';
import { ThunkAction } from '../../../../../../../types/actions';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { getCommentById } from '../../selectors/getCommentById';
import { commentUpdateMeta } from '../../../../../../../rest/effects/card/comments/commentUpdateMeta';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../middlewares/segment';
import { getIsChatViewActive } from '../../../../../../../store/router/selectors/getIsChatViewActive';
import { SegmentCardSourceValue } from '../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onLike = (
    boardId: TBoardId,
    cardId: TCardId,
    commentId: TCommentId
): ThunkAction => {
    return (
        dispatch,
        getState
    ) => {
        const state = getState();
        const { permissionId } = getAuthUser(state);
        const comment = getCommentById(state, cardId, commentId);
        let likes = comment.meta && comment.meta.likes || [];
        const idx = likes.indexOf(permissionId);
        if (idx > -1) {
            likes = likes.filter(id => id !== permissionId)
        } else {
            likes = [...likes, permissionId];
        }
        dispatch(commentUpdateMeta({ likes }, boardId, cardId, commentId));
        dispatch(segmentTrackAction(SegmentCardEvent.COMMENT_LIKE_CLICKED, {
            name: SegmentCardOptions.SOURCE,
            value: getIsChatViewActive(getState()) ? SegmentCardSourceValue.CHAT : SegmentCardSourceValue.CARD,
        }));
    }
}
